import { render } from "./EduardCoceaPage.vue?vue&type=template&id=7d90365c"
import script from "./EduardCoceaPage.vue?vue&type=script&lang=js"
export * from "./EduardCoceaPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__